import { PLUS_MONTHLY_CREDITS_DISPLAY } from './config';
import { MODEL_TOTAL, MODALITY_COUNTS, PROVIDER_TOTAL } from './modelInventory.generated';
import { BILLING } from './pricingContent';

// Compare named individual plans on the same monthly billing cadence.
// Verified September 18, 2026. Recheck before changing claims or prices:
// https://learn.chatgpt.com/docs/pricing
// https://claude.com/pricing
// https://x.ai/pricing
// https://docs.x.ai/grok/faq#usage--limits

export const COMPARISON_PLANS = [
  { id: 'gab', name: 'Gab AI', plan: 'Plus', monthly: BILLING.monthly, featured: true },
  { id: 'chatgpt', name: 'ChatGPT', plan: 'Plus', monthly: 20 },
  { id: 'claude', name: 'Claude', plan: 'Pro', monthly: 20 },
  { id: 'grok', name: 'Grok', plan: 'SuperGrok', monthly: 30 },
];

const included = (label, detail) => ({ label, detail, included: true });
// An omission from a plan page is not evidence that the product cannot do it.
const notListed = { label: 'Not listed' };

export const COMPARISON_ROWS = [
  {
    label: 'Model choice',
    cells: {
      gab: included(`${MODEL_TOTAL} models`, `${PROVIDER_TOTAL} providers, one account`),
      chatgpt: { label: 'OpenAI models' },
      claude: { label: 'Claude models' },
      grok: { label: 'Grok models' },
    },
  },
  {
    label: 'Agents that do the work',
    cells: {
      gab: included('Work mode & Mac app'),
      chatgpt: included('Work & Codex'),
      claude: included('Claude & Claude Code'),
      grok: included('Grok Bot & Build'),
    },
  },
  {
    label: 'Web search & file analysis',
    cells: {
      gab: included('Included'),
      chatgpt: included('Included'),
      claude: included('Included'),
      grok: included('Included'),
    },
  },
  {
    label: 'Image generation',
    cells: {
      gab: included(`${MODALITY_COUNTS.Image} image models`),
      chatgpt: included('Included'),
      claude: notListed,
      grok: included('Grok Imagine'),
    },
  },
  {
    label: 'Video generation',
    cells: {
      gab: included(`${MODALITY_COUNTS.Video} video models`),
      chatgpt: notListed,
      claude: notListed,
      grok: included('Grok Imagine'),
    },
  },
  {
    label: 'AI music generation',
    cells: {
      gab: included('Songs & instrumentals'),
      chatgpt: notListed,
      claude: notListed,
      grok: notListed,
    },
  },
  {
    label: '3D model generation',
    cells: {
      gab: included(`${MODALITY_COUNTS['3D']} 3D models`),
      chatgpt: notListed,
      claude: notListed,
      grok: notListed,
    },
  },
  {
    label: 'Usage transparency',
    cells: {
      gab: included('Clear credit pricing', `${PLUS_MONTHLY_CREDITS_DISPLAY} credits / month. Model costs shown upfront.`),
      chatgpt: { label: 'Variable usage limits', detail: 'Usage varies by model & task' },
      claude: { label: 'Variable usage limits', detail: 'Usage varies by model & task' },
      grok: { label: 'Shared weekly limit', detail: 'Allowance shown as % used' },
    },
  },
  {
    label: 'Everyday chat',
    cells: {
      gab: included('Unlimited in-app chat', 'With the default model'),
      chatgpt: { label: 'Plan limits apply' },
      claude: { label: 'Plan limits apply' },
      grok: { label: 'Plan limits apply' },
    },
  },
];
